/**
 * Created by tdunham on 10/2/2017.
 */
import {Component, Input}   from '@angular/core';
import {NgbActiveModal}     from '@ng-bootstrap/ng-bootstrap';



@Component({
	selector: 'ngbd-modal-content',
	template: `
        <div class="modal-header">
	        
            <h4 class="modal-title">{{title}}</h4>
	        
            <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
	            
                <span aria-hidden="true">&times;</span>
	            
            </button>
	        
        </div>
        
        <div class="modal-body">
	        
            {{text}}
	        
        </div>
        
        <div class="modal-footer">

            <button type="button" class="btn btn-success" (click)="activeModal.close('Publish click')">Publish</button>

            <button type="button" class="btn btn-warning" (click)="activeModal.dismiss('Cancel click')">Cancel</button>
	        
        </div>
	`
})


/**
 * Show a preview window containing the text and headline of the
 * inactive player story that will be published if the editor
 * wishes.
 */
export class PreviewComponent {

	@Input() text:string;

	@Input() title:string;

	constructor(

		public activeModal: NgbActiveModal

	) {}

}


// WEBPACK FOOTER //
// ./src/app/articles/inactives/preview/inactives-preview.component.ts